import { render, staticRenderFns } from "./InvestorHome.vue?vue&type=template&id=401081da&scoped=true&"
import script from "./InvestorHome.vue?vue&type=script&lang=js&"
export * from "./InvestorHome.vue?vue&type=script&lang=js&"
import style0 from "./InvestorHome.vue?vue&type=style&index=0&id=401081da&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401081da",
  null
  
)

export default component.exports